import { useTranslation } from "react-i18next";

import { getInvestmentBasicDataTags } from "./InvestmentBasicData.helpers";

import InvestmentBasicData from "./InvestmentBasicData";

const InvestmentBasicDataContainer = ({
  className,
  withBanner,
  activePosition,
  post,
  calculation,
  conclusionsPro,
  proCalculationCharts,
  onPositionChange,
}: {
  className?: string;
  withBanner?: boolean;
  activePosition: 10 | 20 | 30;
  post?: any;
  calculation: any;
  conclusionsPro: any;
  proCalculationCharts: any;
  onPositionChange: (position: 10 | 20 | 30) => void;
}) => {
  const { t } = useTranslation();

  const tags = getInvestmentBasicDataTags(post, t);

  return (
    <InvestmentBasicData
      className={className}
      withBanner={withBanner}
      activePosition={activePosition}
      tags={tags}
      post={post}
      calculation={calculation}
      conclusionsPro={conclusionsPro}
      proCalculationCharts={proCalculationCharts}
      onPositionChange={onPositionChange}
    />
  );
};

export default InvestmentBasicDataContainer;
